













import { computed, defineComponent, useContext } from "@nuxtjs/composition-api"

import FindProfessionals from "@/components/FindProfessionals.vue"
import TopMenu from "@/components/TopMenu.vue"
import { trackPageVisit } from "@/utils/trackEvents"

export default defineComponent({
  name: "Professionals",
  components: { FindProfessionals, TopMenu },
  layout: "customer",
  middleware: ["disallow-professional"],
  setup() {
    trackPageVisit()
    const { app } = useContext()

    const isLoggedIn = computed(() => app.$accessor.user.hasUser)

    return {
      isLoggedIn,
    }
  },
})
